import { JSX } from 'react';
import { OverlineIcons } from '@ahc-digital/component-library';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { translationClasses } from '@/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from '@/shared/useCreateMarketingRenderingName';
import { CreateC35OverlineIconsModel } from './C35OverlineIcons.service';
import { C35OverlineIconsProps, C35OverlineIconsRouteFields } from './C35OverlineIcons.types';

export const Default = (props?: C35OverlineIconsProps): JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  const routeFields = sitecoreContext?.route?.fields as C35OverlineIconsRouteFields | undefined;
  const overlineIcons = CreateC35OverlineIconsModel(routeFields);

  if (overlineIcons.length === 0) {
    return <></>;
  }

  return (
    <OverlineIcons
      overlineIcons={overlineIcons}
      id={props?.params?.AnchorLinkTargetName}
      className={translationClasses(props?.params)}
      data-component={marketingRenderingName}
    />
  );
};

export default Default;
